export default __webpack_public_path__ + "static/media/gyzj.2c53928a.png";